<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Division 5</h1>
                    <h2>Metals</h2>
                </div>
                <p>
                    PC Haines takes the structural metal framing & trusses very seriously. We realize this complex task sets up the whole integrity of the project and we guarantee 100% quality craftsmanship. Performance that is less than precise can derail the success of your entire project, costing time, money, and quality. PC Haines ensures 100% quality craftsmanship in exterior & interior cold-formed metal framing, cold-formed metal trusses, and metal column covers.
                </p>
                <p>
                    At our company, we make sure every member of our team is highly competent and focused, so that our results exceed expectations and support the project goals. To see what’s involved in our metal work, view our services below.
                </p>
            </div>
            <div class="circles services-circles">
                <pc-services-circles></pc-services-circles>
            </div>
        </div>
    </div>
</div>


<div class="secondary-content-section dark-section">
    
    <div class="site-gutter">
        <div class="card-container">
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">1</span>
                            <h3>Cold-Formed Metal Framing</h3>
                        </div>
                    </div>
                    <p>Cold-form metal framing is a method of construction that uses thin, lightweight sheets of steel, shaped into structural components, to build exterior & interior walls, floors, and roofs. It's prized for its versatility, durability, and ease of use in various building projects. Used for exterior & interior walls which can be load-bearing & ballistic resistant depending on design criteria of a project. </p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">2</span>
                            <h3>Cold-Formed Metal Trusses</h3>
                        </div>
                    </div>
                    <p class="mb">
                        Cold-formed metal trusses are lightweight, prefabricated steel frameworks used to support roofs or floors. They're made by bending thin steel sheets into specific shapes for strength and are known for their durability, ease of installation, and cost-effectiveness. 
                    </p>
                    <p >
                        Cold-formed metal trusses find their way into a variety of buildings. In commercial spaces, they support floors and roofs, providing a framework that's both strong and flexible. They're even used in industrial buildings, taking on heavy loads while keeping the structure lightweight compared to the weight of traditional materials. It's a game-changer for modern construction. 
                    </p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">3</span>
                            <h3>Metal Column Cover</h3>
                        </div>
                    </div>
                    <p>Metal column covers are basically protective and decorative shells, often made from aluminum or steel, that wrap around structural columns. They give a sleek look, hide imperfections, and protect against weather and wear. Metal column covers can be built to architect's specifications and improve the look of exposed steel columns by encasing them. </p>
                </div>
                <div class="card"></div>
            </div>
        </div>
    </div>
</div>

<pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
></pc-seat-belt>